export default "__VITE_ASSET__CWmcNWzx__"